import { View } from './View';
/**
 * A purely declarative type. This object has no additional properties.
 */
export class GpsReading extends View {
}
